// extracted by mini-css-extract-plugin
export default {"domainSelect":"addTxtRecord_domainSelect__zOkWO"};